import { ModalDeleteConfirm } from "App/Component/ui";
import {
	defaultToastSuccess,
	defaultToastError,
	isNull,
} from "App/utils/helpers";
import React, { useState } from "react";

export default function useModalDelete({
	setNewData,
	children,
	handleClickYes,
}) {
	const [dataID, setDataID] = useState(null);
	const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

	function handleClickDelete(id) {
		setDataID(id);
		setShowModalDeleteConfirm(!showModalDeleteConfirm);
	}

	async function deleteList() {
		const response = await handleClickYes(dataID);
		if (response.state) {
			defaultToastSuccess(response.message);
			// await setNewData();
			if (children.length === 0) {
				await setNewData();
			} else {
				await setNewData(1, 10, {
					parent_id_location: children[children.length - 1].id_location,
				});
			}
			/* await setNewData(1, 10, {
				parent_id_location: children[children.length - 1].id_location,
			}); */
		} else {
			defaultToastError(response.message);
		}

		setShowModalDeleteConfirm(false);
	}

	const ModalDelete = () => {
		return (
			<>
				{showModalDeleteConfirm && (
					<ModalDeleteConfirm
						confirmHandle={() => deleteList()}
						setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
					/>
				)}
			</>
		);
	};

	return {
		ModalDelete,
		handleClickDelete,
	};
}
